export default __webpack_public_path__ + "static/media/sideMenu_course.970cc405.svg";